export const filterResolverKey = '@resolver';
//# sourceMappingURL=filters.js.map